var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { COLORS } from 'src/shared/styles/colors';
import styles from './ContactChannelCheckbox.module.scss';
export var ContactChannelCheckbox = function (props) {
    var _a, _b;
    var label = props.label, value = props.value, isActive = props.isActive, isDisabled = props.isDisabled, onToggle = props.onToggle, onKeyDown = props.onKeyDown;
    var checkboxClassName = classNames(styles.checkboxItem, (_a = {},
        _a[styles.disabled] = isDisabled,
        _a[styles.active] = isActive && !isDisabled,
        _a));
    var iconWrapperClassName = classNames(styles.checkboxIconWrapper, (_b = {},
        _b[styles.active] = isActive && !isDisabled,
        _b));
    var handleToggle = function () {
        if (!isDisabled) {
            onToggle();
        }
    };
    var handleKeyDown = function (e) {
        if (!isDisabled) {
            onKeyDown(e);
        }
    };
    return (_jsxs("div", __assign({ role: "checkbox", "aria-checked": isActive && !isDisabled, "aria-disabled": isDisabled, tabIndex: isDisabled ? -1 : 0, className: checkboxClassName, onClick: handleToggle, onKeyDown: handleKeyDown }, { children: [_jsx("div", __assign({ className: iconWrapperClassName }, { children: isActive && !isDisabled && _jsx(Icons, { icon: E_ICONS.CHECK, color: COLORS.WHITE, className: styles.checkIcon }) })), _jsxs("div", __assign({ className: styles.textContainer }, { children: [_jsx("span", __assign({ className: styles.checkboxTitle }, { children: label })), _jsx("span", __assign({ className: styles.checkboxValue }, { children: value }))] }))] })));
};
